<template>
  <div class="drawer-detail">
    <div class="field-type" style="border:none">
      <span class="label">附件:</span>
      <table class="address">
        <thead>
          <td style="width:100px">类型</td>
          <td style="width:150px">附件名称</td>
        </thead>
        <tbody>
          <tr v-for="item in company.附件" :key="item._id">
            <td style="width:100px">{{item['type']}}</td>
            <td style="width:150px" @click="preview(item)">
              <span class="link-item">{{item['originalname']}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="field-type upload-btn-box" style="border:none">
      <el-select class="mr10" v-model="type" filterable size="mini" placeholder="请选择">
        <el-option v-for="item in attachmentTypes" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <el-button type="primary" size="mini" style="margin-bottom:8px" @click="showUpload">附件上传</el-button>
    </div>

    <UploadDialog
      ref="UploadDialog"
      type="附件"
      :label="type"
      :on-success="uploadsuccess"
      :on-error="uploaderror"
    />
  </div>
</template>
<script>
import * as fixedvariant from '../../../../../company/statistics/variant/fixedvariant'

export default {
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['附件'],
      attachmentTypes: fixedvariant.公司附件类型,
      type: '',
    }
  },
  watch: {
    company: {
      handler(newValue, oldValue) {
        if (newValue && !oldValue) this.type = ''
        else if (newValue && oldValue && newValue._id !== oldValue._id) this.type = ''
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 文件预览
    async preview(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      ref.getFile(file)
      ref.show()
    },
    showUpload() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    async uploadsuccess(responce, file, filelist) {
      const type = this.type
      const option = {
        companyId: this.company._id,
        fileId: responce[0]._id,
        md5: responce[0].md5,
        originalname: responce[0].originalname,
        uploader: responce[0].uploader,
        createAt: responce[0].createAt,
        type: type,
        src: responce[0].src,
      }
      const insertRes = await app.service('company').insertCompanyAtta(option)
      if (insertRes.status !== 'success' && insertRes.status !== 200) this.$message.error(insertRes.msg)
      this.getCompanyFiles(this.company._id)
    },
    async uploaderror(responce) {
      console.log(responce)
    },
    async getCompanyFiles(companyId) {
      const result = await app.service('company').getCompanyAtta(companyId)
      if (result.status === 'success') {
        this.company.附件 = result.data
        const formatTye = ['SellingPoint', '公司优劣势', '公司用人偏好', '业务特点/风格/资源来源']
        this.company.附件.forEach(val => {
          if (formatTye.includes(val.type)) val.type = '其他'
        })
      } else this.$message(result.msg)
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
.upload-btn-box {
  margin-top: 30px;
  display: flex;
}
.upload-btn-box .radish-btn {
  flex: none;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
